import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/index.scss'
import './style/font.scss'
import router from './router'
import store from './store'
import App from './App.vue'
import { post, get } from '@/utils/myRequest'
import moment from 'moment'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$getNow = moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
Vue.prototype.$urlPrefix = process.env.VUE_APP_BASE_API_IMG
Vue.prototype.$winpowUrl = process.env.VUE_APP_WINPOW_URL
Vue.prototype.$processMapping = {
  '1': {
    name: '未开始',
    color: '#1466CF'
  },
  '2': {
    name: '报名中',
    color: '#0AC18F'
  },
  '3': {
    name: '待举办',
    color: '#F69F60'
  },
  '4': {
    name: '进行中',
    color: '#EA5504'
  },
  '5': {
    name: '已举办',
    color: '#B5B5B5'
  }
}

Vue.prototype.$typeMapping = {
  E00001: '培训盈',
  E00002: '盈享会',
  E00003: '微路演',
  E00005: '盈峰论',
  E00006: '在盈端',
  E00007: '其他'
}

Vue.prototype.$typeColorMapping = {
  E00001: '#F8B65F',
  E00002: '#03C58B',
  E00003: '#4DC4F5',
  E00005: '#FE8068',
  E00006: '#AB6CEE',
  E00007: '#9a9a9a'
}
Vue.prototype.$bus = new Vue()
Vue.prototype.$axios = axios
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
